import React from 'react';
import ReactDOM from 'react-dom/client';
import gsap from 'gsap';
import './styles/reset.css';
import './styles/common.css';
import './styles/main.scss';
import { store } from 'store/store';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import App from 'App';

gsap.config({
    nullTargetWarn: false,
});

ReactDOM.createRoot(document.getElementById('root')).render(
    <React.StrictMode>
        <Provider store={store}>
            <BrowserRouter>
                <App />
            </BrowserRouter>
        </Provider>
    </React.StrictMode>,
);
